"use client"

import { useEffect } from "react"
import { AlertTriangle } from "lucide-react"

/**
 * Error boundary global (App Router). Remplace l'écran blanc brut de Next.js
 * (« Application error: a client-side exception has occurred ») par un fallback
 * récupérable. `reset()` retente le rendu du segment sans recharger la page.
 */
export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    console.error(error)
  }, [error])

  return (
    <div
      style={{
        minHeight: "100dvh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 24,
        background: "var(--ljs-bg, #F8FAFC)",
      }}
    >
      <div
        style={{
          maxWidth: 420,
          width: "100%",
          textAlign: "center",
          background: "var(--ljs-surface, #fff)",
          border: "1px solid var(--ljs-border, #E2E8F0)",
          borderRadius: 16,
          padding: "32px 28px",
        }}
      >
        <div
          style={{
            width: 48,
            height: 48,
            borderRadius: 12,
            background: "rgba(239,68,68,0.10)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto 18px",
          }}
        >
          <AlertTriangle size={22} style={{ color: "#EF4444" }} />
        </div>
        <h1
          style={{
            fontFamily: "var(--font-heading)",
            fontSize: 18,
            fontWeight: 700,
            color: "var(--ljs-text, #1E293B)",
            margin: "0 0 8px",
          }}
        >
          Une erreur est survenue
        </h1>
        <p style={{ fontSize: 14, color: "var(--ljs-text-dim, #64748B)", margin: "0 0 22px" }}>
          Quelque chose s&apos;est mal passé de notre côté. Vous pouvez réessayer ; si le problème
          persiste, contactez-nous.
        </p>
        <button
          onClick={reset}
          style={{
            padding: "10px 24px",
            borderRadius: 10,
            border: "none",
            background: "var(--ljs-cta, #2563EB)",
            color: "#fff",
            fontSize: 14,
            fontWeight: 600,
            cursor: "pointer",
            fontFamily: "inherit",
          }}
        >
          Réessayer
        </button>
      </div>
    </div>
  )
}
